import { render } from "./password-confirm.vue?vue&type=template&id=6cbb3eba"
import script from "./password-confirm.vue?vue&type=script&lang=js"
export * from "./password-confirm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__